import React, { useState, Fragment, useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { addListing } from "../actions/listing";
import setAuthToken from "../utils/setAuthToken";
import { getListings } from "../actions/listing";
import axios from "axios";

const AddListingForm = ({ addListing, history, user }) => {
  const userid = user.id;

  const [formData, setFormData] = useState({
    name: "",
    description: "",
    price: "",
    photo_url: "",
    user_id: userid,
  });

  const [image, setImage] = useState("");
  const [loading, setLoading] = useState(false);

  const uploadImage = async (e) => {
    const files = e.target.files;
    const data = new FormData();
    data.append("file", files[0]);
    data.append("upload_preset", "images");
    setLoading(true);
    const res = await fetch(
      "https://api.cloudinary.com/v1_1/milo95/image/upload",
      { method: "POST", body: data }
    );
    console.log("returned image response:", res);
    const file = await res.json();
    console.log("returned data img response:", data);

    const img = file.secure_url;

    setFormData({ ...formData, photo_url: img });
    setLoading(false);
  };

  // const fileSelectedHandler = (e) => {
  //   setFormData({
  //     ...formData,
  //     photo: e.target.files[0],
  //   });
  //   console.log(formData);
  // };

  // Destructure Form State
  const { name, description, price, photo_url } = formData;

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setAuthToken(localStorage.token);
    addListing(formData, history);
  };

  // Upload Button Option?
  // const fileUploadHandler = () => {
  //   const fd = new FormData();
  //   fd.append("image", formData.photo, formData.photo.name);
  //   // Make Axios Call with data
  //   console.log(fd);
  // };

  return (
    <div>
      <Fragment>
        <h1 className='large text-primary'>Add Listing</h1>
        <p>* required field</p>
        <form className='form' onSubmit={handleSubmit}>
          <div className='form-group'>
            <input
              type='text'
              placeholder='* name'
              name='name'
              value={name}
              onChange={(e) => onChange(e)}
              required
            />
          </div>
          <div className='form-group'>
            <input
              type='text'
              placeholder='* Description'
              name='description'
              value={description}
              onChange={(e) => onChange(e)}
              required
            />
          </div>
          <div className='form-group'>
            <input
              type='number'
              name='price'
              placeholder='* Price'
              value={price}
              onChange={(e) => onChange(e)}
              required
            />
          </div>
          <div className='form-group'>
            <p>Upload Image</p>
            <input
              type='file'
              name='file'
              placeholder='Upload Image...'
              onChange={uploadImage}
            />
          </div>
          <input type='submit' className='btn btn-primary my-1' />
          <Link className='btn btn-light my-1' to='/my-listings'>
            Go Back
          </Link>
        </form>
      </Fragment>
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.auth.user,
});

export default connect(mapStateToProps, { addListing, getListings })(
  AddListingForm
);
